import { render, staticRenderFns } from "./AutomatorDataTransferSingleEntry.vue?vue&type=template&id=87c8567a&scoped=true"
import script from "./AutomatorDataTransferSingleEntry.vue?vue&type=script&lang=js"
export * from "./AutomatorDataTransferSingleEntry.vue?vue&type=script&lang=js"
import style0 from "./AutomatorDataTransferSingleEntry.vue?vue&type=style&index=0&id=87c8567a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c8567a",
  null
  
)

export default component.exports